<template>
  <div class="loading-mask" v-show="global.loading">
    <div class="mask"></div>
    <div class="loading-message" v-if="global.loadingMessage || message">{{ global.loadingMessage || message }}</div>
  </div>
</template>

<script>
import {mapState} from '../deps/env'

export default {
  name: 'loadingMask',
  props: {
    message: {
      type: String
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['global'])
  },
  methods: {
  }
}
</script>

<style lang="stylus">
.loading-mask {
  position fixed
  height 100vh
  width 100vw
  top 0
  left 0
  overflow hidden
  z-index 99997
  .mask {
    position fixed
    top 0
    left 0
    height 100vh
    width 100vw
    background-color #000
    opacity 0.7
    z-index 99998
  }
  .indicator {
    position fixed
    top 50%
    left 50%
    color #d4a667
    margin-left -15px
    margin-top -45px
    text-align center
    z-index 99999
  }
  .loading-message {
    position fixed
    width 100vw
    top 40vh;
    left 0
    height 2rem
    line-height 2rem
    text-align center
    font-size 14px
    font-weight bold
    color #d4a667
    z-index 99999
  }
}
</style>
